import { forwardRef, HTMLAttributes } from 'react';

import SpinnerIcon from './Spinner.styles';

interface SpinnerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'colour'> {
    /** Colour of spinner. */
    colour?: string;
    /** There are two sizes: small (default) and large. */
    large?: boolean;
}

/** Loading spinner. */
const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
    ({ colour = 'white', large = false, ...props }, ref) => {
        return (
            <SpinnerIcon
                colour={colour}
                large={large}
                data-testid="spinner"
                {...props}
                ref={ref}
            />
        );
    }
);

Spinner.displayName = 'Spinner';

export default Spinner;